import { render, staticRenderFns } from "./qianshouWH.vue?vue&type=template&id=325180b8&scoped=true&"
import script from "./qianshouWH.vue?vue&type=script&lang=js&"
export * from "./qianshouWH.vue?vue&type=script&lang=js&"
import style0 from "./qianshouWH.vue?vue&type=style&index=0&id=325180b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325180b8",
  null
  
)

export default component.exports